<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>Thank you to my sister, Mel, who read through my work. Thank you, Mum and Dad, for always encouraging me in my creative pursuits. And thank you, my husband, Aaron and my son, Samuel, for encouraging me and supporting me.</p>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?12c7d62c